import React from 'react';

// Every footer link now carries a real href. Previously most pointed at "#",
// which gave crawlers nothing to follow and gave users a broken middle-click.
// Links with no destination yet (Careers, Press, Contact, Cookie Policy) were
// removed rather than left as dead "#" anchors — an empty link dilutes internal
// link equity and reads as a broken site to quality raters.
const PLATFORM_LINKS = [
  { label: 'Smart CRM',        page: 'crm',        href: '/CRM' },
  { label: 'Leads Platform',   page: 'leads',      href: '/lead-platform' },
  { label: 'AI Voice Calling', page: 'xfactor',    href: '/The-X-Factor' },
  { label: 'WhatsApp CRM',     page: 'crm',        href: '/CRM' },
  { label: 'Pricing',          page: 'pricing',    href: '/Pricing' },
  { label: 'Comparison',       page: 'comparison', href: '/comparison' },
];

const COMPANY_LINKS = [
  { label: 'About Us', page: 'about', href: '/About-us' },
  { label: 'Blog',     page: 'blog',  href: '/blog' },
  { label: 'FAQ',      page: 'faq',   href: '/faq' },
];

const LEGAL_LINKS = [
  { label: 'Privacy Policy',   page: 'privacy', href: '/privacy-policy' },
  { label: 'Terms of Service', page: 'terms',   href: '/terms-of-service' },
];

export default function Footer({ onNavigate, onTrialClick }) {
  const handle = (event, page) => {
    if (event.metaKey || event.ctrlKey || event.shiftKey || event.button !== 0) return;
    event.preventDefault();
    onNavigate(page);
  };

  const linkStyle = {
    display: 'block', fontSize: 13, color: 'var(--text3)',
    textDecoration: 'none', marginBottom: 9, transition: 'color 0.2s', cursor: 'pointer',
  };

  return (
    <footer>
      <div className="footer-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 44, marginBottom: 44, maxWidth: 1400, margin: '0 auto 44px' }}>
        <div>
          <div style={{ display: 'flex', alignItems: 'center', gap: 8, marginBottom: 16 }}>
            <div style={{ width: 28, height: 28, borderRadius: 8, background: 'var(--blue)', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <svg width="13" height="13" fill="none" stroke="#fff" strokeWidth="2.5" viewBox="0 0 24 24">
                <path d="M6 22V4a2 2 0 0 1 2-2h8a2 2 0 0 1 2 2v18Z"/>
                <path d="M6 12H4a2 2 0 0 0-2 2v6a2 2 0 0 0 2 2h2"/>
                <path d="M18 9h2a2 2 0 0 1 2 2v9a2 2 0 0 1-2 2h-2"/>
              </svg>
            </div>
            <span style={{ fontSize: 16, fontWeight: 800 }}>LEAD-AI</span>
          </div>
          <p style={{ fontSize: 13, color: 'var(--text3)', lineHeight: 1.7, maxWidth: 280 }}>
            AI-powered CRM + Lead Platform built for Indian real estate professionals.
          </p>
          <div style={{ marginTop: 16, display: 'flex', gap: 8 }}>
            <span style={{ fontSize: 10, fontWeight: 700, color: 'var(--green)', background: 'var(--green-glow)', padding: '4px 10px', borderRadius: 20 }}>RERA Compliant</span>
            <span style={{ fontSize: 10, fontWeight: 700, color: 'var(--blue)', background: 'var(--blue-glow)', padding: '4px 10px', borderRadius: 20 }}>Free 1 Year</span>
          </div>
        </div>

        <div className="footer-links" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr 1fr', gap: 32 }}>
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.8, textTransform: 'uppercase', color: 'var(--text3)', marginBottom: 14 }}>Platform</div>
            {PLATFORM_LINKS.map(({ label, page, href }) => (
              <a
                key={label}
                href={href}
                onClick={e => handle(e, page)}
                style={linkStyle}
                onMouseEnter={e => e.target.style.color = 'var(--text)'}
                onMouseLeave={e => e.target.style.color = 'var(--text3)'}
              >{label}</a>
            ))}
          </div>
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.8, textTransform: 'uppercase', color: 'var(--text3)', marginBottom: 14 }}>Company</div>
            {COMPANY_LINKS.map(({ label, page, href }) => (
              <a
                key={label}
                href={href}
                onClick={e => handle(e, page)}
                style={linkStyle}
                onMouseEnter={e => e.target.style.color = 'var(--text)'}
                onMouseLeave={e => e.target.style.color = 'var(--text3)'}
              >{label}</a>
            ))}
          </div>
          <div>
            <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.8, textTransform: 'uppercase', color: 'var(--text3)', marginBottom: 14 }}>Legal</div>
            {LEGAL_LINKS.map(({ label, page, href }) => (
              <a
                key={label}
                href={href}
                onClick={e => handle(e, page)}
                style={linkStyle}
                onMouseEnter={e => e.target.style.color = 'var(--text)'}
                onMouseLeave={e => e.target.style.color = 'var(--text3)'}
              >{label}</a>
            ))}
          </div>
        </div>

        <div>
          <div style={{ fontSize: 11, fontWeight: 700, letterSpacing: 0.8, textTransform: 'uppercase', color: 'var(--text3)', marginBottom: 14 }}>Get Started</div>
          <p style={{ fontSize: 13, color: 'var(--text3)', lineHeight: 1.7, marginBottom: 16 }}>Start for free. No credit card required. Full access for 12 months.</p>
          <button className="btn-primary" style={{ width: '100%', justifyContent: 'center' }} onClick={onTrialClick}>Start Free Now →</button>
        </div>
      </div>

      <div style={{ maxWidth: 1400, margin: '0 auto', borderTop: '1px solid var(--border)', paddingTop: 24, display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 12 }}>
        <div style={{ fontSize: 12, color: 'var(--text3)' }}>© 2024 LEAD-AI. All rights reserved.</div>
        <div style={{ fontSize: 12, color: 'var(--text3)', letterSpacing: 0.3 }}>Technology powered by <a href="https://quan.co.in/" target="_blank" rel="noopener noreferrer" style={{ color: 'inherit', textDecoration: 'underline' }}>Quan</a></div>
        <div style={{ display: 'flex', gap: 20 }}>
          {LEGAL_LINKS.map(({ label, href, page }) => (
            <a
              key={label}
              href={href}
              onClick={e => handle(e, page)}
              style={{ fontSize: 12, color: 'var(--text3)', textDecoration: 'none', cursor: 'pointer' }}
            >{label}</a>
          ))}
        </div>
      </div>

      <style>{`
        /* Tablet */
        @media (min-width: 768px) and (max-width: 1279px) {
          footer { padding-top: 48px !important; padding-bottom: 28px !important; }
          .footer-grid { grid-template-columns: 1fr 1fr !important; gap: 32px !important; }
        }

        /* Mobile */
        @media (max-width: 767px) {
          footer { padding-top: 40px !important; padding-bottom: 24px !important; }
          .footer-grid { grid-template-columns: 1fr !important; gap: 28px !important; }
          .footer-links { gap: 24px !important; }
        }

        @media (max-width: 480px) {
          footer { padding-top: 36px !important; padding-bottom: 20px !important; }
          .footer-grid { gap: 24px !important; }
        }
      `.trim()}</style>
    </footer>
  );
}
